// extracted by mini-css-extract-plugin
export var divider = "_ov-0";
export var systemMessage = "_ov-1";